import { MenuItem } from "./SubMenu";

export const menuItems: MenuItem[] = [
  {
    scrollTo: "home-expand",
    label: "Hem",
  },
  {
    scrollTo: "services-expand",
    label: "Tjänster",
  },
  {
    scrollTo: "contact-expand",
    label: "Kontakt",
  },
];
